/** Formatierungshelfer der Oberflaeche (deutsch, ohne externe Abhaengigkeit). */

const dateTime = new Intl.DateTimeFormat("de-DE", { dateStyle: "short", timeStyle: "medium" });
const timeOnly = new Intl.DateTimeFormat("de-DE", { timeStyle: "medium" });

/** ISO-Zeitstempel als "15.08.26, 10:09:01"; unlesbare Werte kommen unveraendert zurueck. */
export function formatDateTime(iso: string | null | undefined): string {
  if (!iso) return "—";
  const date = new Date(iso);
  return Number.isNaN(date.getTime()) ? iso : dateTime.format(date);
}

export function formatTime(value: Date | null): string {
  return value ? timeOnly.format(value) : "—";
}

/** Sekunden als "1 h 23 min" bzw. "45 min"; unter einer Minute "< 1 min". */
export function formatDuration(seconds: number): string {
  const minutes = Math.floor((seconds || 0) / 60);
  if (minutes < 1) return "< 1 min";
  if (minutes < 60) return `${minutes} min`;
  return `${Math.floor(minutes / 60)} h ${String(minutes % 60).padStart(2, "0")} min`;
}

/** "vor 12 s" / "vor 3 min" - fuer "zuletzt gesehen". */
export function formatAgo(iso: string, now: number = Date.now()): string {
  const seconds = Math.max(0, Math.round((now - new Date(iso).getTime()) / 1000));
  if (seconds < 60) return `vor ${seconds} s`;
  if (seconds < 3600) return `vor ${Math.floor(seconds / 60)} min`;
  return `vor ${Math.floor(seconds / 3600)} h`;
}
